<template>
  <v-list-item>
    <template v-if="miniMenu">
      <v-list-item-avatar style="margin-left: -8px;">
        <v-menu bottom right>
          <template v-slot:activator="{ on }">
            <v-avatar v-on="on" size="34" :color="$randomizeColorFromString(selectedTenant, 75, 70)" class="organization-avatar">
              <span class="text-uppercase font-weight-black white--text">{{ organizationLetters }}</span>
            </v-avatar>
          </template>
          <v-list class="pt-0 pb-0">
            <v-subheader>{{ $t('tenants.choose_organization') }}:</v-subheader>
            <v-list-item v-for="tenant in possibleTenants" @click="selectTenant(tenant)" :key="tenant.id">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{ tenant.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-avatar>
    </template>
    <template v-else>
      <v-autocomplete :label="$t('tenants.organization')"
                outlined
                hide-details
                :disabled="possibleTenants.length < 2"
                class="mt-3 mb-3"
                v-model="selectedTenant"
                :items="possibleTenants"
                item-text="name"
                item-value="id"
                :no-data-text="$t('user_management.no_tenants')"
                @change="tenantSelected">
        <template v-slot:item="data">
            <v-list-item-content >
              <v-list-item-title>
                <v-badge :value="data.item.unreadProposalActivity || data.item.unreadThreadActivity" style="margin-top: 0" :color="badgeColor(data.item)" dot offset-x="-6" offset-y="8">
                  <span>{{data.item.name}}</span>
                </v-badge>
              </v-list-item-title>
            </v-list-item-content>
        </template>
      </v-autocomplete>
    </template>
  </v-list-item>
</template>

<script>
  import tenantService from "../service/tenant.service";

  export default {
    name: 'TenantSelect',
    props: {
      miniMenu: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        selectedTenant: null,
      }
    },
    watch: {
      tenantServiceTenant(to) {
        if (this.selectedTenant !== to) {
          this.selectedTenant = to;
        }
      }
    },
    methods: {
      selectTenant(tenant) {
        this.selectedTenant = tenant.id;
        this.tenantSelected();
      },
      tenantSelected() {
        if ('tenantId' in this.$router.currentRoute.params) {
          const currentParams =  this.$router.currentRoute.params;
          currentParams.tenantId = this.selectedTenant;
          this.$router.push({
            name: 'proposals',
            params: currentParams,
          })
        }
        tenantService.setTenant(this.selectedTenant);
        location.reload();
      },
      badgeColor(t) {
        if (t.unreadProposalActivity && t.unreadThreadActivity) {
          return 'red';
        } else if (t.unreadProposalActivity) {
          return 'blue';
        } else if (t.unreadThreadActivity) {
          return 'green';
        }
        return 'white';
      },
    },
    computed: {
      possibleTenants() {
        return this.$userInfo.tenants;
      },
      organizationLetters() {
        const orgIndex = this.possibleTenants.findIndex(tenant => tenant.id === this.selectedTenant);
        if (orgIndex > -1) {
          return this.possibleTenants[orgIndex].name.substring(0, 2);
        }
        return '';
      },
      tenantServiceTenant() {
        return tenantService.tenant;
      }
    },
    mounted() {
      this.selectedTenant = tenantService.tenant;
    }
  }
</script>

<style lang="scss" scoped>
  .organization-avatar {
    margin: 0;
    cursor: pointer;
  }
</style>
